import React from 'react'
import cs from 'classnames'
import TopMenu from 'component/top-menu'
import Footer from 'component/footer'
import Helmet from 'react-helmet'

const Page = props => (
    <div className={cs('page', props.className)}>
        <Helmet title={"Клуб | " + props.h1} />
        <TopMenu />
        {!!props.h1Label &&
            <div className="h1-label">{props.h1Label}</div>
        }
        <h1>{props.h1}</h1>
        {props.children}
        <Footer />
    </div>
)

export default Page
